<template>
  <div class="home">
    <div class="hero">
      <h1>楓之谷小工具
        <img src="@/assets/shan.gif" alt="Shan Image" />
      </h1>
      <p class="subtitle">提供遊戲相關的計算機和模擬器功能</p>
      <p class="subtitle2">其他功能作者還在開發中...</p>
    </div>
    
    <div class="features-container">
      <div class="features">
        <div class="feature-card">
          <h2>計算機</h2>
          <ul>
            <li><router-link to="/calculator/hexa">六轉進度計算機</router-link></li>
            <li><router-link to="/calculator/exp">經驗計算機</router-link></li>
            <li><span class="disabled-link">經驗回推計算機 (暫時停用)</span></li>
          </ul>
        </div>
        <div class="feature-card">
          <h2>模擬器</h2>
          <ul>
            <li><router-link to="/simulator/jewel">寶玉模擬器</router-link></li>
            <li><router-link to="/simulator/hexa-stats">Hexa屬性模擬器</router-link></li>
          </ul>
        </div>
      </div>

      <!-- 提醒 Section -->
      <div id="reminder" class="hero">
        <h2 id="reminder-title">提醒
        <img src="@/assets/100.gif" alt="石靈的gif" />
        </h2>
        <p class="subtitle">以下功能皆為官方或其他玩家自製，會另開新頁面，僅供參考使用</p>
        <p class="subtitle"></p>
      </div>

      <div class="features">
        <div id="links" class="feature-card">
          <h2 id="links-title">相關連結</h2>
          <ul>
            <li><a href="https://maplestory.beanfun.com/main" target="_blank">官方網站</a></li>
            <li><a href="https://www.facebook.com/www.maplestory.msfans.com.tw/?locale=zh_TW" target="_blank">官方粉絲團</a></li>
            <li><a href="https://home.gamer.com.tw/creationDetail.php?sn=2528312" target="_blank">人物名稱對照表</a></li>
          </ul>
        </div>
        <div id="tools" class="feature-card">
          <h2 id="tools-title">其他好用工具</h2>
          <ul>
            <li><a href="https://xenogents.github.io/LegionSolver/" target="_blank">戰地拼圖計算機</a></li>
            <li><a href="https://msh.astriaworks.moe/" target="_blank">極限屬性計算機</a></li>
            <li><a href="https://maplemaps.net/" target="_blank">怪物地圖</a></li>
          </ul>
        </div>
        <div id="favorites" class="feature-card favorites-card">
          <h2 id="favorites-title" class="favorites-title">
            我的收藏
            <img v-if="favorites.length > 0" src="@/assets/set.png" alt="設定收藏" class="settings-icon" @click="toggleSettingsMode" />
          </h2>
          <p v-if="favorites.length === 0" class="favorites-description">新增常用網址，成為專屬收藏</p>
          <ul>
            <li v-for="(tool, index) in favorites" :key="index" :class="{ 'edit-mode': isSettingsMode }">
              <div class="favorite-item" :class="{ 'edit-mode': isSettingsMode }">
                <a :href="tool.link" target="_blank" 
                  @click.prevent="isSettingsMode ? null : window.open(tool.link, '_blank')">
                  {{ tool.name }}
                </a>
                <div v-if="isSettingsMode" class="edit-buttons">
                  <button class="edit-btn" @click="openEditModal(index)">編輯</button>
                  <button class="delete-btn" @click="deleteFavorite(index)">刪除</button>
                </div>
              </div>
            </li>
            <li v-if="!isSettingsMode">
              <a href="javascript:void(0)" @click="openModal" class="favorite-link">➕ 新增收藏</a>
            </li>
            <li v-if="isSettingsMode" class="done-button-container">
              <button @click="toggleSettingsMode" class="done-button">完成</button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 新增收藏 Modal -->
    <div v-if="showModal" class="modal" @click.self="closeModal">
      <div class="modal-content">
        <span class="close" @click="closeModal">&times;</span>
        <h3>新增收藏</h3>
        <label for="toolName">名稱：</label>
        <input id="toolName" v-model="toolName" type="text" placeholder="請輸入名稱" maxlength="16" autocomplete="off">
        <label for="toolLink">連結：</label>
        <input id="toolLink" v-model="toolLink" type="url" placeholder="請輸入URL連結 (例如 https://...)" autocomplete="off">
        <button @click="addFavorite">新增</button>
      </div>
    </div>

    <!-- 修改收藏 Modal -->
    <div v-if="showEditModal" class="modal" @click.self="closeEditModal">
      <div class="modal-content">
        <span class="close" @click="closeEditModal">&times;</span>
        <h3>修改收藏</h3>
        <label for="editToolName">名稱：</label>
        <input id="editToolName" v-model="editToolName" type="text" placeholder="請輸入名稱" maxlength="16" autocomplete="off">
        <label for="editToolLink">連結：</label>
        <input id="editToolLink" v-model="editToolLink" type="url" placeholder="請輸入URL連結 (例如 https://...)" autocomplete="off">
        <button @click="updateFavorite">修改</button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      hover: false,
      showModal: false,
      showEditModal: false,
      toolName: '',
      toolLink: '',
      editToolName: '',
      editToolLink: '',
      currentEditIndex: null,
      favorites: [],
      isSettingsMode: false
    };
  },
  mounted() {
    this.loadFavorites();
  },
  methods: {
    loadFavorites() {
      const storedFavorites = localStorage.getItem('favorites');
      if (storedFavorites) {
        try {
          this.favorites = JSON.parse(storedFavorites);
        } catch (e) {
          console.error('Error parsing favorites from localStorage', e);
          localStorage.removeItem('favorites'); // 清除損壞的資料
        }
      }
    },
    saveFavorites() {
      localStorage.setItem('favorites', JSON.stringify(this.favorites));
    },
    openModal() {
      this.toolName = ''; // 清空上次輸入
      this.toolLink = ''; // 清空上次輸入
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    addFavorite() {
      if (!this.toolName.trim()) {
        alert('請輸入名稱');
        return;
      }
      if (!this.toolLink.trim()) {
        alert('請輸入連結');
        return;
      }
      // 簡單的 URL 驗證 (可根據需要加強)
      try {
        new URL(this.toolLink);
      } catch (_) {
        alert('請輸入有效的URL連結，必須包含 http:// 或 https://');
        return;
      }

      this.favorites.push({ name: this.toolName.trim(), link: this.toolLink.trim() });
      this.saveFavorites();
      this.closeModal();
    },
    openEditModal(index) {
      this.editToolName = this.favorites[index].name;
      this.editToolLink = this.favorites[index].link;
      this.currentEditIndex = index;
      this.showEditModal = true;
    },
    closeEditModal() {
      this.showEditModal = false;
    },
    updateFavorite() {
      if (!this.editToolName.trim()) {
        alert('請輸入名稱');
        return;
      }
      if (!this.editToolLink.trim()) {
        alert('請輸入連結');
        return;
      }
      // 簡單的 URL 驗證 (可根據需要加強)
      try {
        new URL(this.editToolLink);
      } catch (_) {
        alert('請輸入有效的URL連結，必須包含 http:// 或 https://');
        return;
      }

      // 修改當前正在編輯的項目
      if (this.currentEditIndex !== null && this.currentEditIndex >= 0 && this.currentEditIndex < this.favorites.length) {
        this.favorites[this.currentEditIndex] = {
          name: this.editToolName.trim(),
          link: this.editToolLink.trim()
        };
        this.saveFavorites();
        this.closeEditModal();
      }
    },
    deleteFavorite(index) {
      const confirmDelete = confirm('確定要刪除這個收藏嗎？');
      if (confirmDelete) {
        this.favorites.splice(index, 1);
        this.saveFavorites();
      }
    },
    toggleSettingsMode() {
      this.isSettingsMode = !this.isSettingsMode;
    }
  }
}
</script>

<style scoped>
.home {
  padding: 2rem 0;
}

.hero {
  text-align: center;
  margin-bottom: 3rem;
  animation: fadeIn 0.8s ease;
}

.hero h1 {
  font-size: 2.5rem;
  color: var(--secondary-color);
  margin-bottom: 1rem;
}

.hero h2 {
  font-size: 1.5rem;
  color: var(--secondary-color);
  margin-bottom: 1rem;
}

.hero h2 img {
  width: 100px;
  height: 100px;
  margin-bottom: auto;
}

.subtitle {
  font-size: 1.2rem;
  color: var(--text-color);
  opacity: 0.8;
}

.subtitle2 {
  font-size: 1rem;
  color: var(--text-color);
  opacity: 0.8;
}

.features-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  margin-top: 2rem;
}

.features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 1.5rem;
  width: 100%;
  max-width: calc(350px * 2 + 1.5rem * 1);
  justify-content: center;
}

.feature-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  transition: transform var(--transition-speed) ease;
  text-align: center;
  width: 350px;
  margin: 0 auto;
}

.feature-card:hover {
  transform: translateY(-5px);
}

.feature-card h2 {
  color: var(--primary-color);
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.feature-card ul {
  list-style: none;
  padding: 0;
}

.feature-card li {
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
}

.feature-card li:last-child {
  border-bottom: none;
}

.card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  transition: transform var(--transition-speed) ease;
}

.card:hover {
  transform: translateY(-5px);
}

.card-link {
  text-decoration: none;
  color: inherit;
  display: block;
  height: 100%;
}

.card-link:hover {
  text-decoration: none;
  color: inherit;
}

.feature-card a {
  color: var(--text-color);
  text-decoration: none;
  transition: all var(--transition-speed) ease;
  padding: 0.5rem 0;
  display: block;
  width: 100%;
  border-radius: 6px;
}

.feature-card a:hover {
  color: white;
  background-color: var(--nav-hover);
}

@media (max-width: 768px) {
  .hero h1 {
    font-size: 2rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
  
  .features {
    grid-template-columns: 1fr;
    max-width: 100%;
    padding: 0 1rem;
    gap: 2rem;
  }
  
  .feature-card {
    width: 100%;
    max-width: 100%;
    margin: 0;
  }

  .feature-card ul {
    padding: 0 1rem;
  }

  .feature-card li {
    padding: 0.75rem 0;
  }

  .feature-card a {
    padding: 0.75rem;
    display: block;
    width: 100%;
    text-align: center;
  }
  
  .favorites-card {
    grid-column: span 1;
    width: 100%;
  }
  
  .favorites-card ul {
    padding: 0;
  }
  
  .favorites-card ul li {
    width: 100%;
  }

  .favorites-card ul li a {
    padding: 0.75rem;
  }

  #links, #tools {
    grid-column: 1 / -1;
  }
}

.add-tool-btn {
  background-color: var(--nav-bg);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color var(--transition-speed) ease;
  margin-top: 0.5rem;
  display: inline-block;
}

.add-tool-btn:hover {
  background-color: var(--nav-hover);
}

.feature-card li:has(> .add-tool-btn) {
  border-bottom: none;
}

.modal {
  position: fixed;
  z-index: 1001;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 2rem;
  border: 1px solid #888;
  width: 80%;
  max-width: 500px;
  border-radius: 12px;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
  position: relative;
  text-align: left;
}

.modal-content h3 {
  margin-top: 0;
  color: var(--primary-color);
  text-align: center;
  margin-bottom: 1.5rem;
}

.modal-content label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.modal-content input[type=text],
.modal-content input[type=url] {
  width: 100%;
  padding: 10px;
  margin-bottom: 1rem;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.modal-content button {
  background-color: var(--primary-color);
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  width: 100%;
  transition: background-color var(--transition-speed) ease;
  font-size: 1rem;
}

.modal-content button:hover {
  background-color: var(--nav-hover);
}

.close {
  color: #aaa;
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 28px;
  font-weight: bold;
  line-height: 1;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.favorites-title {
  position: relative; 
  padding-right: 40px; 
}

.settings-icon {
  width: 30px;
  height: 30px;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.favorite-item {
  position: relative;
  box-sizing: border-box;
  width: 100%;
}

.favorite-item.edit-mode {
  padding: 8px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.03);
  margin-bottom: 0.25rem;
}

.favorites-card ul li.edit-mode {
  border-bottom: none; 
}

.edit-buttons {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.edit-btn {
  background-color: #888;
  color: white;
  border: none;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
}

.delete-btn {
  background-color: #e74c3c;
  color: white;
  border: none;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
}

.favorites-card {
  grid-column: span 2;
  width: 100%;
  max-width: 100%;
  margin: 0;
}

.favorites-card ul {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  gap: 1.5rem;
  justify-content: flex-start;
}

.favorites-card ul li {
  width: calc(50% - 0.75rem);
  padding: 0;
  border-bottom: none;
  box-sizing: border-box;
}

.favorites-card ul li a {
  display: block;
  width: 100%;
  text-align: center;
  padding: 0.5rem 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-color);
  background-color: #eee;
  border-radius: 6px;
  transition: all var(--transition-speed) ease;
  text-decoration: none;
}

.favorites-card ul li a:hover {
  color: white;
  background-color: var(--nav-hover);
}

.favorites-card ul li:has(> .add-tool-btn) {
  width: 100%;
  text-align: center;
  margin-top: 1rem; 
}

.favorite-link {
  display: block;
  width: 100%;
  text-align: center;
  padding: 0.5rem 0;
  color: var(--text-color);
  background-color: #eee;
  border-radius: 6px;
  text-decoration: none;
  transition: all var(--transition-speed) ease;
  cursor: pointer;
}

.favorite-link:hover {
  color: white;
  background-color: var(--nav-hover);
}

.done-button-container {
  width: 100% !important;
  text-align: center;
  margin-top: 1.5rem;
  padding-top: 1rem;
}

.done-button {
  background-color: #27ae60; 
  color: white;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color var(--transition-speed) ease;
}

.done-button:hover {
  background-color: #2ecc71; 
}

.no-favorites {
  width: 100% !important;
  text-align: center;
  padding: 1rem 0;
}

.no-favorites p {
  margin-bottom: 1rem;
  color: #777;
}

.no-favorites .favorite-link {
  display: inline-block;
  width: auto;
  padding: 0.5rem 1.5rem;
}

.favorites-description {
  font-size: 0.9rem;
  color: #666;
  margin: -0.5rem 0 1rem 0;
  text-align: center;
}

.disabled-link {
  color: #999;
  cursor: not-allowed;
  padding: 0.5rem 0;
  display: block;
  width: 100%;
  border-radius: 6px;
  opacity: 0.6;
}
</style> 